
import { defineComponent } from "vue";
import TokenService from "@/services/TokenService";
import GameService from "@/services/GameService";
import ResponseData from "@/_models/ResponseData";
import { Helper } from "@/utils/Helper";
import store from "@/store/index";

export default defineComponent({
  data: function () {
    return {
      tokens: [],
      attachedTokens: [],
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      selectAttachedToken: "",
      selectedToken: null,
      isDisplayGameTokenModel: false,
    };
  },

  name: 'GamesTabGameTokenComponent',
  components: {},
  methods: {
    getTokensList() {
      if (this.userData !== "") {
        TokenService.getTokenListByWalletAddress(this.userData.testnetWalletAddress, 'testnet')
          .then((response: ResponseData) => {
            this.tokens = response.data;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    getAttachedTokens() {
      if (this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId.toString();
        GameService.getAttachedTokensToGame(gameId)
          .then((response: ResponseData) => {
            console.log(response)
            if (response.status !== 204) {
              this.attachedTokens = response.data.viewModel;
            }
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    selectAttachedTokenFunc(id: string) {
      this.selectAttachedToken = id;
      this.selectedToken = id;
    },

    saveAttachedToken() {
      let gameId = this.$route.params.gameId.toString();

      if (
        this.$route.params.gameId !== undefined &&
        this.userData !== "" &&
        this.jwtToken !== ""
      ) {
        TokenService.attachTokensToGame(
          this.selectAttachedToken,
          gameId,
          this.userData.userId,
          this.jwtToken,
          'testnet'
        )
          .then((response) => {
            if(response.status == 200){
              this.getAttachedTokens();
              this.isDisplayGameTokenModel = false;
              Helper.toastSuccessHandling(response.data.message)
            }
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },
  },

  computed: {
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
  },

  mounted() {
    this.getTokensList();
    this.getAttachedTokens();
  },
});
